<template>
  <CChartLine
    :datasets="computedDatasets"
    :options="computedOptions"
    :labels="label || labels"
  />
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'
import { getColor } from '@coreui/utils/src'
import deepObjectsMerge from '@/utils/deepObjectsMerge'

export default {
  name: 'CChartLineSimple',
  components: { CChartLine },
  props: {
    ...CChartLine.props,
    borderColor: {
      type: String,
      default: 'rgba(255,255,255,.55)'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    dataPoints: {
      type: Array,
      default: () => [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12]
    },
    label: {
      type: String,
      default: 'Sales'
    },
    labels: {
      type: Array,
      default: () => []
    },
    datasets: {
      type: Array,
      default: () => null
    },
    options: {
      type: Object,
      default: () => ({})
    },
    pointed: Boolean,
    pointHoverBackgroundColor: String
  },
  computed: {
    computedDataPoints () {
      if (this.datasets && this.datasets.length) {
        const dataPoints = []
        this.datasets.forEach(ds => {
          dataPoints.push(...ds.data)
        })
        return dataPoints
      }

      return this.dataPoints
    },
    pointHoverColor () {
      if (this.pointHoverBackgroundColor) {
        return this.pointHoverBackgroundColor
      } else if (this.backgroundColor !== 'transparent') {
        return this.backgroundColor
      }
      return this.borderColor
    },
    defaultDatasets () {
      return [
        {
          data: this.computedDataPoints,
          borderColor: getColor(this.borderColor),
          backgroundColor: getColor(this.backgroundColor),
          pointBackgroundColor: getColor(this.pointHoverColor),
          pointHoverBackgroundColor: getColor(this.pointHoverColor),
          label: this.label
        }
      ]
    },
    pointedOptions () {
      return {
        scales: {
          xAxes: [
            {
              offset: true,
              gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
              },
              ticks: {
                fontSize: 2,
                fontColor: 'transparent'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: true,
                min: Math.min.apply(Math, this.computedDataPoints) - 5,
                suggestedMax: Math.max.apply(Math, this.computedDataPoints) + 5
              }
            }
          ]
        },
        elements: {
          line: {
            borderWidth: 5
          },
          point: {
            radius: 4,
            hitRadius: 4,
            hoverRadius: 6
          }
        }
      }
    },
    straightOptions () {
      return {
        scales: {
          xAxes: [
            {
              display: false,
              offset: false,
              gridLines: {
                drawTicks: false,
                color: 'red',
                zeroLineColor: 'red'
              },
              ticks: {
                display: false,
                fontSize: 2,
                fontColor: 'red'
              }
            }
          ],
          yAxes: [{
            display: false,
            offset: false,
            gridLines: {
              drawTicks: false,
              color: 'green',
              zeroLineColor: 'black'
            },
            ticks: {
              display: false,
              min: 0,
              suggestedMax: Math.ceil(Math.max.apply(Math, this.computedDataPoints) + Math.max.apply(Math, this.computedDataPoints) / 3)
            }
          }]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 0,
            hitRadius: 4,
            hoverRadius: 6
          }
        }
      }
    },
    defaultOptions () {
      const options = this.pointed ? this.pointedOptions : this.straightOptions
      return Object.assign({}, options, {
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      })
    },
    computedDatasets () {
      return deepObjectsMerge(this.defaultDatasets, this.datasets || {})
    },
    computedOptions () {
      return deepObjectsMerge(this.defaultOptions, this.options || {})
    }
  }
}
</script>
